import React, { useState } from "react";
import RenderChatMessages from "../ChatMessage/index";
import { useDispatch, useSelector } from "react-redux";
import { OPEN_CHAT_ELEMENT_SUCCESS } from "../../../types/conversations";
import { motion, AnimatePresence } from "framer-motion";
import { CLOSE_CHAT_MODAL_SUCCESS } from "../../../types/chat";
import List from "./List";

const MediumChatBox = () => {
    const openedChatBoxData = useSelector((state) => state.chat.openedChatBoxData);
    const foregroundChats = openedChatBoxData.filter(({ openInBackground }) => !openInBackground);
    const visibleChats = foregroundChats.slice(-2);
    const visibleChatIds = new Set(visibleChats.map(({ chatId }) => chatId));
    const sidebarChats = openedChatBoxData.filter(({ chatId }) => !visibleChatIds.has(chatId));
    const dispatch = useDispatch();
    const [isChatMinimized, setIsChatMinimized] = useState({});

    const handleCloseChat = (id) => {
        setIsChatMinimized((prevState) => {
            const updatedState = { ...prevState };
            delete updatedState[id];
            return updatedState;
        });
        dispatch({ type: CLOSE_CHAT_MODAL_SUCCESS, payload: [id] });
    };

    const handleOpenChat = (id, conversationName) => {
        dispatch({ type: OPEN_CHAT_ELEMENT_SUCCESS, payload: { _id: [id], status: true, conversationName } })
    };

    const handleChatArrowClick = (chatId) => {

        setIsChatMinimized(prev => ({
            ...prev,
            [chatId]: !prev[chatId]
        }));
    };

    const chatContainerVariants = {
        hidden: { opacity: 0, scale: 0.95 },
        visible: {
            opacity: 1,
            scale: 1,
            transition: {
                type: "spring",
                stiffness: 300,
                damping: 30
            }
        },
        exit: {
            opacity: 0,
            scale: 0.95,
            transition: { duration: 0.2 }
        }
    };

    return (
        <motion.div
            className={`pointer-events-none fixed ${sidebarChats.length > 0 ? 'right-[24rem]' : 'right-[1vw]'} bottom-7 bg-transparent flex gap-6 items-end z-50`}
            initial="hidden"
            animate="visible"
            variants={chatContainerVariants}
        >
            <AnimatePresence mode="popLayout">
                {visibleChats.map(({ chatId, defaulOpentChecklist = false }) => (
                    <motion.div
                        key={chatId}
                        className={`pointer-events-auto backdrop-blur-xl bg-white/95 
                            ${isChatMinimized[chatId] ? 'h-[3.75rem]' : 'h-[42rem]'}
                            w-[35rem] shadow-2xl rounded-2xl border border-gray-100 flex-1 overflow-hidden
                            transition-all duration-500 ease-in-out transform hover:shadow-xl`}
                        layout
                        initial={{ y: 50, opacity: 0 }}
                        animate={{ y: 0, opacity: 1 }}
                        exit={{ y: 50, opacity: 0 }}
                        transition={{
                            type: "spring",
                            stiffness: 400,
                            damping: 30
                        }}
                    >
                        <RenderChatMessages
                            chat_id={chatId}
                            handleCloseChat={handleCloseChat}
                            mainDivClass="h-full rounded-2xl"
                            isChatPopup
                            handleChatArrowClick={() => handleChatArrowClick(chatId)}
                            isChatMinimized={isChatMinimized[chatId]}
                            defaulOpentChecklist={defaulOpentChecklist}
                        />
                    </motion.div>
                ))}
            </AnimatePresence>
            <motion.div
                className="pointer-events-auto mediumChatSidebar fixed right-[1vw] bottom-6 max-h-[65%] flex flex-col gap-4"
                initial={{ x: 100, opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                transition={{
                    type: "spring",
                    stiffness: 400,
                    damping: 30
                }}
            >
                <AnimatePresence>
                    {openedChatBoxData && openedChatBoxData.length > 0 && (
                        <motion.div
                            initial={{ scale: 0.9, opacity: 0 }}
                            animate={{ scale: 1, opacity: 1 }}
                            exit={{ scale: 0.9, opacity: 0 }}
                            transition={{
                                type: "spring",
                                stiffness: 400,
                                damping: 30
                            }}
                        >
                            <List
                                sidebarChats={sidebarChats}
                                onClick={handleOpenChat}
                            />
                        </motion.div>
                    )}
                </AnimatePresence>
            </motion.div>
        </motion.div>
    );
};

export default MediumChatBox;
